<template>
	<div id="applyDetail">
		<div v-title>售后详情</div>

		<scroller :on-infinite="infinite" :on-refresh="refresh" refreshText="下拉刷新" ref="myscroller" noDataText="" style="padding-top: 1.466666rem;">
			<div class="status">{{data.status | formatStatus}}</div>
			<div class="de-container">
				<div class="detail-cont" v-for="item in reList">
					<div class="header">
						<img :src="user.headpic" class='user-header' v-if="item.haveAppraise" />
						<div style="display: inline-block;font-size: 0;" v-else>
							<img :src="user.headpic" class='user-header' v-if="item.source=='3'" />
							<img src="https://misc.reflower.com.cn/images/customer/customer.png" v-if="item.source=='2'" />
							<img src="https://misc.reflower.com.cn/images/customer/logo.png" v-if="item.source=='1'" />
						</div>
						<div class="time-box" v-if="item.haveAppraise">
							<p class="name">{{user.nickname}}</p>
							<p class="create-time">{{item.createTime}}</p>
						</div>
						<div class="time-box" v-else>
							<p class="name" v-if="item.source=='3'">{{user.nickname}}</p>
							<p class="name" v-else>{{item.createUser}}</p>
							<p class="create-time">{{item.createTime}}</p>
						</div>
					</div>
					<p class="pro-content">{{item.content}}</p>
					<div class="img-box clearfix" id="imgboxid" v-if="item.images.length>0">
						<div class="img-item" v-for="(item1,index) in item.images">
							<img :src='item1' @click="showBig(item1)" />
						</div>
					</div>
				</div>
			</div>
			<!--<div class="no-data">{{noData}}</div>-->
			<div class="appraise-box" v-show="canAppraise">
				<div class="star-box">
					<span class="app-font">服务评价</span>
					<div class="star-con">
						<span v-for="(itemClass,index) in itemClasses" :class="itemClass" class="star-item" :track-by="index" @click="stars(index)"></span>
					</div>
					<span class="remark">{{startText[score -1]}}</span>
				</div>
        <div class="star-box">
        	<span class="app-font">商品评价</span>
        	<div class="star-con">
        		<span v-for="(itemClass,index) in itemClassesGood" :class="itemClass" class="star-item" :track-by="index" @click="goodStars(index)"></span>
        	</div>
        	<span class="remark">{{startText[goodsScore -1]}}</span>
        </div>
        <div class="star-box">
        	<span class="app-font">物流评价</span>
        	<div class="star-con">
        		<span v-for="(itemClass,index) in itemClassesLog" :class="itemClass" class="star-item" :track-by="index" @click="logisticsStars(index)"></span>
        	</div>
        	<span class="remark">{{startText[logisticsScore-1]}}</span>
        </div>
				<div class="solve-box">
					问题是否已解决
					<span :class="{'solve':true, 'solve-y':!isSolve,'solve-yc':isSolve}" @click="chkSolve">已解决</span>
					<span :class="{'solve':true, 'solve-n':!noSolve,'solve-nc':noSolve}" @click="chkNoSolve">未解决</span>
				</div>
				<div class="praise-sub" @click="praiseSub">提交评价</div>
			</div>
			<div class="praise-done" v-if="hasAppraise">
				<div class="detail-cont">
					<div class="header">
						<img :src="user.headpic" class='user-header' />

						<div class="time-box">
							<p class="name">{{user.nickname}}</p>
							<p class="create-time">{{data.createTime}}</p>
						</div>
					</div>
					<p class="pro-content">{{data.praiseName}}</p>
				</div>
				<div class="praise-bo">
					<div class="star-box">
						<span class="app-font">服务评价</span>
						<div class="star-con">
							<span v-for="(itemClass,index) in itemClasses" :class="itemClass" class="star-item" :track-by="index"></span>
						</div>
						<span class="remark">{{startText[score-1]}}</span>
					</div>
          <div class="star-box">
          	<span class="app-font">商品评价</span>
          	<div class="star-con">
          		<span v-for="(itemClass,index) in itemClassesGood" :class="itemClass" class="star-item" :track-by="index"></span>
          	</div>
          	<span class="remark">{{startText[goodsScore -1]}}</span>
          </div>
          <div class="star-box">
          	<span class="app-font">物流评价</span>
          	<div class="star-con">
          		<span v-for="(itemClass,index) in itemClassesLog" :class="itemClass" class="star-item" :track-by="index"></span>
          	</div>
          	<span class="remark">{{startText[logisticsScore-1]}}</span>
          </div>
					<div class="solve-box">
						问题是否已解决
						<span class="solve" :class="{ 'solve-y':!isSolve,'solve-yc':isSolve}">已解决</span>
						<span class="solve" :class="{ 'solve-n':!noSolve,'solve-nc':noSolve}">未解决</span>
					</div>
				</div>

			</div>

		</scroller>
		<div class="send-container">
			<div class="img-container" v-show="showImg">
				<div class="img-box" id="imgboxid">
					<div class="img-item" v-for="(item,index) in imgArr">
						<span class="del-img" @click="delImg(index)">
								<img src="https://misc.reflower.com.cn/images/customer/delete.png" />
							</span>
						<img :src="item" />
					</div>
				</div>
				<input type='file' id="imgInp" @change="upimg($event)" name="imgFile" accept="image/*" style="display: none;" />
				<img id="blah0" class="add-img" @click="checkipt()" v-if="imgArr.length<3" src="https://misc.reflower.com.cn/images/customer/camera.png" alt="显示您上传的商品图片" />
			</div>
			<div class="send-box" v-if="data.status!='3'&& data.status!='4' && data.status!='5' ">
				<img class="camera-li" src="https://misc.reflower.com.cn/images/customer/camera_li.png" @click="checkipt()" />
				<textarea v-model="content" placeholder="补充问题描述" id="textarea"></textarea>
				<div class="send-btn" @click="sendMsg">
					<img src="https://misc.reflower.com.cn/images/customer/reply-send.png" />
				</div>
			</div>
		</div>
		<div class="explain-wrap" v-show="showExplain" @click="hideBig">
			<div class="content-boxb">
				<img v-if="transImg!=''" :src="transImg" />
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import VueScroller from 'vue-scroller'
	import '../../static/lib/layer.js'

	Vue.use(VueScroller);

	export default {
		data() {
			return {
				offset: 0,
				limit: 10,
				formId: '',
				data: {},
				reList: [],
				content: '',
				noData: '',
				imgArr: [],
				showImg: false,
				score: 0,
				canAppraise: false,
				hasAppraise: false,
				starRemark: '',
				isSolve: false,
				noSolve: false,
				solveNum: 0,
				user: {},
				showExplain: false,
				transImg: '',
        startText: ['不满意 ', '一般 ', '比较满意', '满意 ', '非常满意'],
        goodsScore: 0,//商品服务
        logisticsScore: 0,//物流服务
			}
		},

		computed: {
			itemClasses() {
				this.score > 5 ? this.scroe = 5 : this.score;
				let result = [];
				let score = Math.floor(this.score * 2) / 2;
				let hasDecimal = score % 1 != 0;
				let integer = Math.floor(score);
				for(let i = 0; i < integer; i++) {
					result.push("on")
				}

				while(result.length < 5) {
					result.push("off")
				}
				return result
			},
      itemClassesLog() {
      	this.logisticsScore > 5 ? this.scroe = 5 : this.logisticsScore;
      	let result = [];
      	let score = Math.floor(this.logisticsScore * 2) / 2;
      	let hasDecimal = score % 1 != 0;
      	let integer = Math.floor(score);
      	for(let i = 0; i < integer; i++) {
      		result.push("on")
      	}

      	while(result.length < 5) {
      		result.push("off")
      	}
      	return result
      },
      itemClassesGood() {
      	this.goodsScore > 5 ? this.goodsScore = 5 : this.goodsScore;
      	let result = [];
      	let score = Math.floor(this.goodsScore * 2) / 2;
      	let hasDecimal = score % 1 != 0;
      	let integer = Math.floor(score);
      	for(let i = 0; i < integer; i++) {
      		result.push("on")
      	}

      	while(result.length < 5) {
      		result.push("off")
      	}
      	return result
      }
		},

		created() {
//			this.chkLogin();
			this.formId = this.$route.query.formId;
			this.getDetailA();
		},
		mounted() {
			jQuery.fn.extend({
				autoHeight: function() {
					return this.each(function() {
						var $this = jQuery(this);
						if(!$this.attr('_initAdjustHeight')) {
							$this.attr('_initAdjustHeight', $this.outerHeight());
						}
						_adjustH(this).on('input', function() {
							_adjustH(this);
						});
					});
					/**
					 * 重置高度
					 * @param {Object} elem
					 */
					function _adjustH(elem) {
						var $obj = jQuery(elem);
						return $obj.css({
								height: $obj.attr('_initAdjustHeight'),
								'overflow-y': 'hidden'
							})
							.height(elem.scrollHeight);
					}
				}
			});
			// 使用
			$(function() {
				$('textarea').autoHeight();
			});
		},
		methods: {
			getDetail: function() {
				this.http({
					url: this.details + this.formId,
					method: 'get'
				}).then(res => {
					if(res.data.httpCode == 200) {
						this.data = res.data.data;
						this.data.img = JSON.parse(this.data.images)[0];
						this.data.images = JSON.parse(this.data.images);
						this.data.content = res.data.data.problemContent;

						//						this.getReplyList();
					}
				})
			},

			getDetailA: function() {
				let _this = this;
				$.ajax({
					url: _this.details + _this.formId,
					type: 'get',
					cache: false,
					async: false,
					processData: false,
					contentType: false,
					dataType: "json",
					success: function(res) {
						if(res.httpCode == 200) {
							_this.data = res.data;

							if(_this.data.images != "" && _this.data.images != null) {
								_this.data.img = JSON.parse(_this.data.images)[0];
								_this.data.images = JSON.parse(_this.data.images);
							}

							_this.data.content = res.data.problemContent;
							if(res.data.haveAppraise == '2') {
								_this.data.praiseName = '已评价';
                //三种服务评价分
                if(_this.data.appraiseScoreStr != ""){
                  let appraiseScoreStr = JSON.parse(_this.data.appraiseScoreStr)
                  _this.goodsScore = parseInt(appraiseScoreStr.goodsScore);
                  _this.logisticsScore = parseInt(appraiseScoreStr.logisticsScore)
                }
                //老数据/新评价 服务评价
								 _this.score = parseInt(res.data.appraiseScore);
								// _this.stars(_this.score);
								if(res.data.appraiseResult == '1') {
									_this.isSolve = true;
								} else {
									_this.noSolve = true;

								}
							}
              // console.log(appraiseScoreStr,'appraiseScoreStr')

							_this.getUserInfo();
						}
					}
				});
			},

			getReplyList: function(offset, done) {
				let hdu = this.getCookie('hdu');
				let param = {
					pageNumber: this.offset,
					pageSize: this.limit,
					formId: this.formId,
				};

				console.log(this.offset)
				this.http({
					url: this.replyList,
					method: 'post',
					data: param
				}).then(res => {
					if(res.data.httpCode == 200) {
						let data = res.data.data;
						if(offset == 1) {
							this.reList = [];
						}
						if(data.length > 0) {
							for(let temp of data) {
								if(temp.images != '' && temp.images != null) {
									temp.images = JSON.parse(temp.images);
									temp.isuser = true;
								}
								this.reList.push(temp);
							}

						} else {
							if(this.reList.length > 0) {
								var _this = this;
								this.noData = "-没有更多数据了-";
								setTimeout(() => {
									//没有数据了 执行 finishInfinite(2)
									_this.$refs.myscroller.finishInfinite(2);

									if(_this.data.canAppraise == '2') {
										_this.canAppraise = true;
									};

									if(_this.data.haveAppraise == '2') {
										_this.hasAppraise = true;
									}
								}, 10)

							} else {}

							return
						}

						this.$refs.myscroller.finishPullToRefresh();
						//当前下拉加载结束之后，执行done方法，以便下一次下拉加载正常执行
						done();
						if(this.reList.indexOf(this.data) == -1) {
							this.reList.unshift(this.data);
						}

						this.reList.map(item => {
							if(item.source == '2') {
								item.createUser = '花小妹'
							}
						})
						console.log(this.reList, 'this.reList')
					}
				})
			},

			//获取用户信息
			getUserInfo: function() {
				let _this = this;
				let uid = this.getCookie('hdu');
				let hdt = this.getCookie('hdt');
				$.ajax({
					url: _this.userInfo,
					type: 'post',
					async: false,
					type: 'post',
					xhrFields: {
						withCredentials: true
					},
					contentType: "application/json",
					crossDomain: true,
					dataType: "json",
					success: function(res) {
						if(res.code == 2000) {
							_this.user = res.data
						} else if(res.code == 1010) {
							_this.delCookie('hdu');
							_this.delCookie('hdt');
							if(!uid || !hdt) {
								_this.$router.push({
									path: '/'
								})
							}

						} else {
							_this.popUp(res.msg)
						}
					}
				});
			},

			//创建回复
			sendMsg: function() {
				let arr = new Array();
				let load = 'https://misc.reflower.com.cn/images/customer/uploading.png';
				this.imgArr.map(item => {
					if(item != load) {
						arr.push(item)
					}
				});

				let param = {
					formId: this.formId,
					content: this.content,
					images: JSON.stringify(arr)
				}
				if(this.content == "") {
					this.popUp('请输入回复内容')
				} else {
					this.http({
						url: this.userSave,
						method: "post",
						data: param
					}).then(res => {
						if(res.data.httpCode == 200) {
							this.popUp('消息发送成功');
							this.content = "";
							location.reload();
						} else {
							this.popUp(res.data.msg)
						}

					})
				}

			},

			upimg: function(event) {
				console.log(event.target.files)
				var _this = this;
				var imgurl = this.upload;
				var iamges = new Array();
				var file1 = event.target.files;
				for(var i = 0; i < file1.length; i++) {
					var file = file1[i];
					(function(file, i) {
						var reader = new FileReader();
						iamges[i] = new Image();
						reader.readAsDataURL(file);
						reader.onloadend = function(e) {
							var ace = this.result;
							iamges[i].src = ace;
						};
						let loStr = 'https://misc.reflower.com.cn/images/customer/uploading.png';
						_this.imgArr.splice(i, 0, loStr);
						iamges[i].onload = function() {
							var w = iamges[i].width;
							var h = iamges[i].height;
							var ratio, multiplier;
							if(w < 720 && h < 720) { //小于100K 的不压缩
								multiplier = 1;
								ratio = 0.8;
							} else {
								ratio = 1;
								if(w < 720 && h >= 720) {
									multiplier = 720 / h;
								} else if(w >= 720 && h < 720) {
									multiplier = 720 / w;
								} else {
									multiplier = 720 / Math.max(w, h);
									ratio = 0.8;
								}
							}
							var imageData = _this.compress(iamges[i], w * multiplier, h * multiplier, ratio);
							var formData = new FormData();
							formData.append("imageData", imageData);
							$.ajax({
								url: imgurl,
								type: 'POST',
								cache: false,
								data: formData,
								async: false,
								processData: false,
								contentType: false,
								dataType: "json",
								xhrFields: {
									withCredentials: true
								},
								crossDomain: true,
								success: function(msg) {
									console.log(i, 'i')
									if(msg.code == 1) {
										var str = 'http://img.reflower.com.cn/' + msg.data;
										if(_this.imgArr.length <= 3) {

											_this.imgArr.splice(i, 1);
											_this.imgArr.push(str);
										} else {
											return
										}

										console.log(_this.imgArr, '_this.imgArr')
									} else {
										_this.popUp(msg.desc)
									}

								}
							});
						}
					})(file, i)

				}
			},

			//BIG
			showBig: function(item) {
				this.showExplain = true;
				this.transImg = item;
			},

			hideBig: function() {
				this.showExplain = false;
			},

			//显示上传图片box

			sendImg: function() {

			},

			//已解决
			chkSolve: function() {
				this.isSolve = true;
				this.noSolve = false;
				this.solveNum = 1;
			},

			//未解决
			chkNoSolve: function() {
				this.noSolve = true;
				this.isSolve = false;
				this.solveNum = 2;
			},

			praiseSub: function() {
				let param = {
					formId: this.formId,
					appraiseResult: this.solveNum,
          appraiseScore: this.score,
          appraiseScoreStr:{
            // appraiseScore: this.score,
            goodsScore: this.goodsScore,
            logisticsScore: this.logisticsScore
          }
				};
				if(this.score == 0) {
					this.popUp('请选择服务评分！')
				}else if(this.goodsScore == 0){
          this.popUp('请选择商品评分！')
        }else if(this.logisticsScore == 0){
          this.popUp('请选择物流评分！')
        }else if(this.solveNum == 0) {
					this.popUp('请选择问题解决情况')
				}else {
					this.sendPraise(param)
				}

			},

			sendPraise: function(param) {
				this.http({
					url: this.appraise,
					method: 'post',
					data: param
				}).then(res => {
					if(res.data.httpCode == 200) {
						this.popUp('您的评价已收到！');
						location.reload();
					} else {
						this.popUp(res.data.msg)
					}
				})
			},

			checkipt: function() {
				if(this.imgArr.length == 3) {
					this.popUp('最多上传3张图片！')
				} else {
					$('#imgInp').trigger("click");
					this.showImg = true;
				}
			},

			//刪除圖片
			delImg: function(index) {
				this.imgArr.splice(index, 1);
				if(this.imgArr.length == 0) {
					this.showImg = false;
				}
			},

			//选择星
			stars: function(val) {
				this.score = parseInt(val) + 1;
				let starArr = new Array('不满意 ', '一般 ', '比较满意', '满意 ', '非常满意');
				this.starRemark = starArr[this.score - 1];
				console.log(this.score, 'ss')
			},
      //物流选星
      logisticsStars(val){
        this.logisticsScore = parseInt(val) + 1;
      },
      //商品选星
      goodStars(val){
        this.goodsScore = parseInt(val) + 1;
      },

			infinite: function(done) {
				this.offset++;
				this.getReplyList(this.offset, done);
			},

			refresh: function(done) {
				this.offset = 1;
				this.getReplyList(1, done);
			},
			getCookie: function(name) { //获取cookie
				var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
				if(arr = document.cookie.match(reg)) {
					var data = unescape(arr[2]);
					return data;
				} else {
					return '';
				}
			},
			delCookie: function(name) { //删除cookie
				var exp = new Date();
				exp.setTime(exp.getTime() - 1);
				var cval = this.getCookie(name);
				console.log(this.getCookie(name))
				document.cookie = name + "=" + cval + ";path=/;domain=reflower.com.cn;expires=" + exp.toGMTString() + "";
				console.log(document.cookie)
			},

			//tost
			popUp: function(content) {
				layer.open({
					content: content,
					skin: 'msg',
					time: 2 //2秒后自动关闭
				});
			},
			compress: function(img, width, height, ratio) {
				var canvas, ctx, img64;
				canvas = document.createElement('canvas');
				canvas.width = width;
				canvas.height = height;
				ctx = canvas.getContext("2d");
				ctx.drawImage(img, 0, 0, width, height);
				img64 = canvas.toDataURL("image/jpeg", ratio);
				return img64;
			},
			chkLogin: function() {
				let uid = this.getCookie('hdu');
				let hdt = this.getCookie('hdt');
				let ua = navigator.userAgent.toLowerCase();
				let loginurl = this.loginurl;
				let wechaturl = this.wechaturl;
				let alipayurl = this.alipayurl;
				let alipayoauth2url = 'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2017021505685120&redirect_uri=';
				let oauth2url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx05d6a1410a2236e1&redirect_uri=';
        // let oauth2url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxaa2aa6cc330cd7bf&redirect_uri=';
				if(!!!uid || !!!hdt) {
					var currenturl = window.location.href;
					if(currenturl.indexOf('?') < 0) {
						currenturl += "?";
					} else {
						currenturl += "&";
					}
					if(ua.match(/MicroMessenger/i) == "micromessenger") {
						//   	console.log("wechaturl: "+wechaturl + "||| currenturl: "+currenturl );
						var redirectUrl = encodeURIComponent(wechaturl + currenturl);
						//   	console.log("redirectUrl"+redirectUrl);
						var resultUrl = oauth2url + redirectUrl + "&response_type=code&scope=snsapi_base&state=login#wechat_redirect";
						window.location.href = resultUrl;
					} else if(ua.indexOf("alipay") >= 0) {
						var redirectUrl = encodeURIComponent(alipayurl + currenturl);
						var resultUrl = alipayoauth2url + redirectUrl + "&scope=auth_user,auth_zhima";
						window.location.href = resultUrl;
					} else {
						window.location.href = loginurl + currenturl;
					}
				}
			},
		},
		filters: {
			formatStatus: function(value) {
				let val = "";
				switch(value) {
					case "1":
						val = "待领取"
						break;
					case "2":
						val = "处理中"
						break;
					case "3":
						val = "已完成"
						break;
					case "4":
						val = "已取消"
						break;
					case "5":
						val = "已关闭"
						break;
					case "21":
						val = "待用户寄回"
						break;
					case "22":
						val = "待商家收货"
						break;
					case "23":
						val = "商家已签收"
						break;
					case "24":
						val = "退款中"
						break;
					case "25":
						val = "商家拒收"
						break;
				}
				return val
			}
		}
	}
</script>

<style scoped>
	/*开启用户复制文字*/
	._v-container[data-v-ecaca2b0] {
		webkit-user-select: auto;
		/*webkit浏览器*/
		-khtml-user-select: auto;
		/*早期浏览器*/
		-moz-user-select: auto;
		/*火狐*/
		-ms-user-select: auto;
		/*IE10*/
		user-select: auto;
	}

	#applyDetail {
		padding-bottom: 1.466666rem;
	}

	.status {
		width: 100%;
		height: 1.466666rem;
		color: #FFFFFF;
		font-size: 0.48rem;
		background-color: #C4D275;
		line-height: 1.466666rem;
		padding-left: 0.8rem;
		text-align: left;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		opacity: 1;
	}

	.de-container {
		margin: 0 0.213333rem;
	}

	.detail-cont {
		margin-top: 0.213333rem;
		padding: 0.4rem 0.4rem;
		background-color: #FFFFFF;
	}

	.detail-cont .header {
		display: flex;
		display: -webkit-flex;
		flex-direction: row;
		-webkit-flex-direction: row;
		text-align: left;
	}

	.header img {
		width: 1.2rem;
		height: 1.2rem;
	}

	.time-box {
		margin-left: 0.32rem;
	}

	.time-box .name {
		font-size: 0.373333rem;
		margin-bottom: 0.266666rem;
	}

	.time-box .create-time {
		font-size: 0.32rem;
		color: #999999;
	}

	.pro-content {
		text-align: left;
		font-size: 0.373333rem;
		line-height: 0.56rem;
		margin-top: 0.4rem;
	}

	.img-box {
		padding-top: 0.333333rem;
	}

	.img-box .img-item {
		float: left;
		width: 1.6rem;
		height: 1.6rem;
		position: relative;
		margin-right: 0.32rem;
	}

	.img-box .img-item img {
		display: block;
		width: 1.6rem;
		height: 1.6rem;
	}

	.img-box .img-item .del-img {
		display: inline-block;
		height: 0.453333rem;
		height: 0.453333rem;
		position: absolute;
		right: -0.226666rem;
		top: -0.226666rem;
	}

	.img-container {
		padding: 0 0 0 0.4rem;
	}

	.img-container .add-img {
		display: block;
		width: 1.6rem;
		height: 1.6rem;
	}

	.clearfix:after {
		content: ".";
		display: block;
		clear: both;
		visibility: hidden;
		font-size: 0;
	}

	.send-container {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 100%;
	}

	.send-box {
		background-color: #FFFFFF;
		min-height: 1.28rem;
		width: 100%;
		padding: 0.266666rem 0.4rem;
		display: flex;
		display: -webkit-flex;
		align-items: center;
		-webkit-align-items: center;
		/*justify-content: space-between;*/
		flex-direction: row;
		-webkit-flex: row;
		/*-webkit-justify-content: space-between;*/
		border-top: 1px solid #DDDDDD;
		width: 100%;
	}

	.send-box .camera-li {
		width: 0.586666rem;
		margin-right: 0.293333rem;
	}

	.send-box .send-btn {
		margin-left: 0.293333rem;
		/*width: 0.56rem;
		height: 0.426666rem;*/
	}

	.send-box .send-btn img {
		display: block;
		width: 0.56rem;
	}

	textarea {
		resize: none;
		display: block;
		width: 7.466666rem;
		height: 0.746666rem;
		line-height: 0.533333rem;
		border-color: #CCCCCC;
		outline: none;
		font-size: 0.346666rem;
	}

	textarea::-webkit-input-placeholder {
		color: #999;
	}

	.img-container {
		background-color: #FFFFFF;
		border-top: 1px solid #DDDDDD;
		height: 2.426666rem;
	}

	.img-box .img-item {
		float: left;
		width: 1.6rem;
		height: 1.6rem;
		position: relative;
		margin-right: 0.32rem;
	}

	.img-box .img-item img {
		display: block;
		width: 1.6rem;
		height: 1.6rem;
	}

	.img-box .img-item .del-img {
		display: inline-block;
		height: 0.453333rem;
		height: 0.453333rem;
		position: absolute;
		right: -0.226666rem;
		top: -0.226666rem;
	}

	.img-box .img-item .del-img img {
		width: 0.453333rem;
		height: 0.453333rem;
	}

	input {
		font-size: 0;
		outline: none;
		border: none;
		display: none;
		opacity: 0;
		background-color: #FFFFFF;
	}

	.user-header {
		border: 1px solid #EBEBEB;
	}

	.no-data {
		height: 1.333333rem;
		width: 100%;
		line-height: 1.333333rem;
		z-index: 0;
		font-size: 0.4rem;
		text-align: center;
		color: #999999;
	}

	.appraise-box {
    margin: 0 0.213333rem;
    padding-bottom: 0.48rem;
		min-height: 4.933333rem;
		background-color: #FFFFFF;
		border-top: 1px solid #DDDDDD;
	}

	.star-item {
		display: inline-block;
		background-repeat: no-repeat;
		width: 0.533333rem;
		height: 0.533333rem;
		background-size: 100%;
		margin-right: 0.4rem;
	}

	.star-box {
		margin-top: 0.506666rem;
		font-size: 0.373333rem;
		height: 0.533333rem;
		display: flex;
		display: -webkit-flex;
		align-items: center;
		-webkit-align-items: center;
		/*justify-content: space-between;*/
		padding: 0 0.4rem;
	}

	.star-box .app-font {
		margin-right: 0.453333rem;
	}

	.star-box .star-con {
		/*margin-right: 1.333333rem;*/
	}

	.star-box .remark {
		flex: 1;
		-webkit-flex: 1;
		text-align: right;
		color: #999999;
		font-size: 0.373333rem;
	}

	.star-item.on {
		background-image: url(https://misc.reflower.com.cn/images/customer/star2.png);
	}

	.star-item.off {
		background-image: url(https://misc.reflower.com.cn/images/customer/star.png);
	}

	.solve-box {
		font-size: 0.373333rem;
		margin-top: 0.64rem;
		padding: 0 0.4rem;
		text-align: left;
		height: 0.533333rem;
	}

	.solve {
		display: inline-block;
		width: 1.866666rem;
		height: 0.533333rem;
		text-indent: 0.666666rem;
		margin-left: 0.8rem;
	}

	.solve-y {
		background: url(https://misc.reflower.com.cn/images/customer/praise_l.png) no-repeat left center;
		background-size: 0.506666rem auto;
	}

	.solve-n {
		background: url(https://misc.reflower.com.cn/images/customer/praise_garyl.png) no-repeat left center;
		background-size: 0.506666rem auto;
	}

	.solve-yc {
		background: url(https://misc.reflower.com.cn/images/customer/praise.png) no-repeat left center;
		background-size: 0.506666rem auto;
		color: #C4D275;
	}

	.solve-nc {
		background: url(https://misc.reflower.com.cn/images/customer/praise_gary.png) no-repeat left center;
		background-size: 0.506666rem auto;
		color: #C4D275;
	}

	.praise-sub {
		margin: 0.693333rem 0.48rem 0 0.48rem;
		height: 1.066666rem;
		line-height: 1.066666rem;
		background-color: #C8D678;
		font-size: 0.48rem;
		color: #FFFFFF;
		border-radius: 0.08rem;
	}

	.praise-done {
    margin: 0 0.213333rem;
		background-color: #FFFFFF;
	}

	.praise-bo {
		border-top: 1px solid #DDDDDD;
		padding-bottom: 0.64rem;
	}

	.explain-wrap {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 1000;
	}

	.explain-wrap::before {
		content: '';
		z-index: 0;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: #000;
		opacity: 0.7;
	}

	.content-boxb {
		z-index: 3001;
		width: 8.8rem;
		/*height: 12.666666rem;*/
		border-radius: 0.106666rem;
		position: absolute;
		background-color: #fff;
		left: 50%;
		top: 50%;
		-webkit-transform: translate(-50%, -50%);
		-o-transform: translate(-50%, -50%);
		-moz-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}

	.content-boxb img {
		display: block;
		width: 100%;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/path/applyDetail.vue